import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Offer from './pages/Offer';
import PreRegistration from './pages/PreRegistration';
import Contacts from './pages/Contacts';
import Gallery from './pages/Gallery';
import NotFound from './pages/NotFound';

const App = () => (
  <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <ScrollToTop />
    <Navbar />
    <main className="main-content ">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/offer" element={<Offer />} />
        <Route path="/pre-registration" element={<PreRegistration />} />
        <Route path="/contacts" element={<Contacts />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </main>
    <Footer />
  </Router>
);

export default App;